module.exports = __webpack_public_path__ + "static/img/2.6b8223f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/2.jpg
// module id = x2VO
// module chunks = 1